import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Cost} from '../../models/cost';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class CostService extends AbstractModelService<Cost> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/cost', Cost);
  }

  getStatistics(params: any): Observable<any[]> {
    return new Observable<any[]>(subscriber => {
      this.apiClient.get('/cost/statistics', params).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
